import Heading from '../../components/common/Heading/Heading';
import DynamicTableAnt from '../../hooks/DynamicTableAnt';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from '../../services/react-query/queryKeys';
import { DownOutlined, PlusOutlined } from '@ant-design/icons';
import {
  getPaymentEntries,
  getPaymentReceiptVoucher,
  getPaymentVoucher,
} from '../../network/PaymentEntry';
import PaymentAction from './PaymentAction';
import { useEffect, useState } from 'react';
import { Button, Dropdown, Flex, message } from 'antd';
import { AddbulkAction } from '../../network/salesInvoice';
import { useNavigate } from 'react-router-dom';
import {
  ModalAddBankTransfer,
  ModalAppPdfData,
} from '../../components/upeosoft/ModalApp/ModalApp';
import DashboardCards from '../Dashboard/DashboardCards';

const PaymentEntry = ({ t, payment, receipt, stockPayment }) => {
  const client = useQueryClient();
  const navigate = useNavigate();
  const {
    searchText,
    columns,
    openBankTransfer,
    setOpenBankTransfer,
    idPayment,
    openPdf,
    pdfData,
    setOpenPdf,
    nameInvoice,
    onGetPDF,
    setLoadingPdf,
    loadingPdf,
  } = PaymentAction({ t });
  const [searchKey, setSearchKey] = useState('');
  const [actionType, setActionType] = useState('');
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const { mutate: onAddbulkAction } = useMutation({
    mutationKey: ['AddbulkAction'],
    mutationFn: (selectNames) =>
      AddbulkAction('Payment Entry', actionType, selectNames),
    onSuccess: (data) => {
      console.log(data?.message, 'data');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      setSelectedRowKeys([]);
      message.success(
        actionType === 'cancel' ? 'Cancel successfully' : 'Submit successfully'
      );
      client.invalidateQueries({
        queryKey: [
          queryKeys.getPaymentEntries,
          searchText.key,
          searchText.value,
        ],
      });
    },
    onError: (error) => {
      const serverMessages = JSON.parse(error.response.data._server_messages);
      const messageData = JSON.parse(serverMessages[0]);
      const title = messageData.title || 'Error';
      const messageContent = messageData.message || 'An error occurred';
      message.error({
        content: `${title}: ${messageContent.replace(/<[^>]*>/g, '')}`,
        duration: 5,
      });
    },
  });
  const { data, isLoading } = useQuery({
    queryKey: [queryKeys.getPaymentEntries, searchText.key, searchText.value],
    queryFn: () =>
      getPaymentEntries({ key: searchText.key, value: searchText.value }),
    keepPreviousData: true,
    enabled: !!payment,
  });

  const { data: receiptData, isLoading: receiptLoading } = useQuery({
    queryKey: [
      queryKeys.getPaymentReceiptVoucher,
      searchText.key,
      searchText.value,
    ],
    queryFn: () =>
      getPaymentReceiptVoucher({
        key: searchText.key,
        value: searchText.value,
      }),
    keepPreviousData: true,
    enabled: !!receipt,
  });
  const { data: stockPaymentData, isLoading: stockPaymentLoading } = useQuery({
    queryKey: [queryKeys.getPaymentVoucher, searchText.key, searchText.value],
    queryFn: () =>
      getPaymentVoucher({ key: searchText.key, value: searchText.value }),
    keepPreviousData: true,
    enabled: !!stockPayment,
  });
  // const dataTable = ()=>{
  //   if(receiptData){
  //     setSelectData(receiptData?.data);
  // return data?.data?.map((item, index) => {
  //   return {
  //     ...item,
  //     key: item?.name,
  //   };
  // });
  //   } else {
  //     setSelectData(data?.data);
  // return receiptData?.data?.map((item, index) => {
  //   return {
  //     ...item,
  //     key: item?.name,
  //   };
  // });
  //   }
  // }
  const onSelectChange = (newSelectedRowKeys) => {
    // console.log('selectedRowKeys changed: ', newSelectedRowKeys);
    setSelectedRowKeys(newSelectedRowKeys);
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  return (
    <div className="payment-entry">
      {/* <Heading
        title={stockPayment ? t.Inventory : t.Finance}
        subTitle={
          receipt
            ? t.ReceiptVoucher
            : payment
            ? t.paymentEntry
            : t.PaymentVoucher
        }
        path="/"
      /> */}
      <DashboardCards t={t} />
      <div className="mt-5">
        {payment ? (
          <DynamicTableAnt
            columns={columns}
            data={data?.data?.map((item, index) => {
              return {
                ...item,
                key: item?.name,
              };
            })}
            loading={isLoading}
            // setSearchText={setSearchText}
            rowSelection={rowSelection}
            titleBtn={t.AddPaymentEntry}
            buttonModal={
              <Flex align="center" gap={10}>
                <Dropdown
                  menu={{
                    items: [
                      {
                        label: t.submit,
                        key: '2',
                        onClick: () => {
                          setActionType('submit');
                          onAddbulkAction(selectedRowKeys);
                        },
                        disabled: !selectedRowKeys?.length,
                      },
                      {
                        label: t.cancel,
                        key: '3',
                        onClick: () => {
                          setActionType('cancel');
                          onAddbulkAction(selectedRowKeys);
                        },
                        disabled: !selectedRowKeys?.length,
                      },
                    ],
                  }}
                >
                  <Button type="primary" ghost icon={<DownOutlined />}>
                    {t.action}
                  </Button>
                </Dropdown>
                <Button
                  type="primary"
                  onClick={() => navigate('/payment-entry/add')}
                >
                  <PlusOutlined size={10} /> {t.AddPaymentEntry}
                </Button>
              </Flex>
            }
            // Placeholder={t.searchPartyName}
            Placeholder={t.searchPartyName + ' ' + t.or + ' ' + t.id}
            pathBtn="/payment-entry/add"
          />
        ) : receipt ? (
          <DynamicTableAnt
            columns={columns}
            data={receiptData?.data?.map((item, index) => {
              return {
                ...item,
                key: item?.name,
              };
            })}
            loading={receiptLoading}
            rowSelection={rowSelection}
            titleBtn={t.AddPaymentEntry}
            buttonModal={
              <Flex align="center" gap={10}>
                <Dropdown
                  menu={{
                    items: [
                      {
                        label: t.submit,
                        key: '2',
                        onClick: () => {
                          setActionType('submit');
                          onAddbulkAction(selectedRowKeys);
                        },
                        disabled: !selectedRowKeys?.length,
                      },
                      {
                        label: t.cancel,
                        key: '3',
                        onClick: () => {
                          setActionType('cancel');
                          onAddbulkAction(selectedRowKeys);
                        },
                        disabled: !selectedRowKeys?.length,
                      },
                    ],
                  }}
                >
                  <Button type="primary" ghost icon={<DownOutlined />}>
                    {t.action}
                  </Button>
                </Dropdown>
                <Button
                  type="primary"
                  onClick={() => navigate('/payment-entry-receipt-voucher/add')}
                >
                  <PlusOutlined size={10} /> {t.addReceiptVoucher}
                </Button>
              </Flex>
            }
            // Placeholder={t.searchPartyName}
            Placeholder={t.searchPartyName + ' ' + t.or + ' ' + t.id}
            pathBtn="/payment-entry/add"
          />
        ) : (
          <DynamicTableAnt
            columns={columns}
            data={stockPaymentData?.data?.map((item, index) => {
              return {
                ...item,
                key: item?.name,
              };
            })}
            loading={stockPaymentLoading}
            rowSelection={rowSelection}
            titleBtn={t.AddPaymentEntry}
            buttonModal={
              <Flex align="center" gap={10}>
                <Dropdown
                  menu={{
                    items: [
                      {
                        label: t.submit,
                        key: '2',
                        onClick: () => {
                          setActionType('submit');
                          onAddbulkAction(selectedRowKeys);
                        },
                        disabled: !selectedRowKeys?.length,
                      },
                      {
                        label: t.cancel,
                        key: '3',
                        onClick: () => {
                          setActionType('cancel');
                          onAddbulkAction(selectedRowKeys);
                        },
                        disabled: !selectedRowKeys?.length,
                      },
                    ],
                  }}
                >
                  <Button type="primary" ghost icon={<DownOutlined />}>
                    {t.action}
                  </Button>
                </Dropdown>
                <Button
                  type="primary"
                  onClick={() => navigate('/payment-entry/add')}
                >
                  <PlusOutlined size={10} /> {t.AddPaymentEntry}
                </Button>
              </Flex>
            }
            Placeholder={t.searchPartyName + ' ' + t.or + ' ' + t.id}
            pathBtn="/payment-entry/add"
          />
        )}
      </div>
      <ModalAddBankTransfer
        t={t}
        open={openBankTransfer}
        setOpen={setOpenBankTransfer}
        editId={idPayment}
      />
      <ModalAppPdfData
        open={openPdf}
        pdfData={pdfData}
        setOpen={setOpenPdf}
        nameInvoice={nameInvoice}
        t={t}
        onGetPDF={onGetPDF}
        type="Payment Entry"
        setLoadingPdf={setLoadingPdf}
        loadingPdf={loadingPdf}
      />
    </div>
  );
};

export default PaymentEntry;
